module.exports = __webpack_public_path__ + "static/restaurant_leteppanyaki01-67561fdfb894b7f5e9cc2244695d1ec1.jpg";